module.exports = __webpack_public_path__ + "img/luowenzhou.prt.c418c426.jpg";